import React from 'react';
import {
  Prelead,
  ProjectGroupPreleadCustomizeItem,
  PreleadProjectGroupCustomizeItemNumber,
  useUpdateProjectGroupPreleadCustomizeItemNumberMutation,
} from 'api';
import {Input as UIInput} from 'components/antd';
import styled from 'styled-components';

interface Props {
  prelead: Prelead;
  projectGroupPreleadCustomizeItem: ProjectGroupPreleadCustomizeItem;
}

export default ({prelead, projectGroupPreleadCustomizeItem}: Props) => {
  const customizeItem = prelead.projectGroupCustomizeItemNumbers.find(
    (item: PreleadProjectGroupCustomizeItemNumber) =>
      item.projectGroupPreleadCustomizeItemId ===
      projectGroupPreleadCustomizeItem.id,
  );

  const [value, setValue] = React.useState(
    customizeItem ? customizeItem.value : null,
  );

  React.useEffect(() => {
    setValue(customizeItem ? customizeItem.value : null);
  }, [customizeItem]);

  const [updateCustomizeItem] =
    useUpdateProjectGroupPreleadCustomizeItemNumberMutation();

  const update = (e: any) => {
    updateCustomizeItem({
      variables: {
        uuid: prelead.uuid,
        projectGroupPreleadCustomizeItemId: projectGroupPreleadCustomizeItem.id,
        value: e.target.value ? Number(e.target.value) : null,
      },
    });
  };

  return (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={update}
      onPressEnter={update}
      type="number"
      placeholder="未入力"
    />
  );
};

const Input = styled(UIInput)`
  border-color: transparent;
  background-color: transparent;
  border-radius: 4px;

  &:hover {
    border: 1px solid var(--text-color-3);
  }
`;
